import { ReactNode } from 'react';
import { Close } from '@styled-icons/remix-fill';

import theme from 'styles/theme';
import defaultImage from 'v3/assets/images/people-car-keys.png';

import * as S from './styles';

export type PromotionalModalProps = {
  open: boolean;
  onCancel: () => void;
  title: string | ReactNode;
  image?: string;
  width?: number;
  content: string | ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
};

const PromotionalModal = ({
  open,
  title,
  content,
  image = defaultImage,
  width = 575,
  onCancel,
  className,
  variant = 'primary',
}: PromotionalModalProps) => {
  return (
    <S.Modal
      centered
      footer={null}
      onCancel={onCancel}
      open={open}
      width={width}
      closeIcon={<Close size={18} color={theme.colors.neutralSilver50} />}
      className={className}
    >
      <S.ModalContent>
        <S.Title variant={variant}>{title}</S.Title>
        {content}
      </S.ModalContent>
      <S.Image src={image} alt="Promotional image" />
    </S.Modal>
  );
};

export default PromotionalModal;
